import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

export const pagesPropTypes = {
  applicationData: PropTypes.object,
  changedFields: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  validationErrors: PropTypes.object.isRequired,
  validateField: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  entityId: PropTypes.string.isRequired,
  setEntityConfig: PropTypes.func.isRequired,
  setInitialFormValues: PropTypes.func.isRequired,
  entitiesSideData: PropTypes.object.isRequired,
  initialEntitiesSideData: PropTypes.object.isRequired,
  setEntitiesSideData: PropTypes.func.isRequired,
  setInitialEntitiesSideData: PropTypes.func.isRequired,
  setIsSavingAllowed: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired,
  setInForm: PropTypes.func.isRequired,
  setMultipleInForm: PropTypes.func.isRequired,
  staticValidateField: PropTypes.func.isRequired,
  section: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabledPendingChangesHighlight: PropTypes.bool.isRequired,
  pendingChanges: PropTypes.object.isRequired,
  openedSectionsRef: PropTypes.object.isRequired,
  newEntities: PropTypes.array.isRequired,
  deletedEntities: PropTypes.array.isRequired,
  isNewEntityFlow: PropTypes.bool.isRequired,
  setIsNestedEntityEditActive: PropTypes.func.isRequired,
  updateEntitiesApplicationData: PropTypes.func,
  ...WithLoadingPropTypes,
};

export const SPOUSE_TYPE = {
  BORROWER: 'Borrower',
  NON_BORROWER: 'NonBorrowerEntity',
  OTHER: 'Other',
};
